(function () {
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function hoistModalsToBody() {
    qsa('.ts-mcf-modal').forEach(function(modal){
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hoistModalsToBody);
  } else {
    hoistModalsToBody();
  }

})();

(function () {
  function qs(sel, root) { return (root || document).querySelector(sel); }

  function openModal(id, trigger) {
    var modal = qs('#' + id + '-dialog');
    if (!modal) return;

    modal.hidden = false;
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');

    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var panel = qs('.ts-mcf-modal__panel', modal);
    if (panel) panel.focus();

    modal.dataset.tsOpen = '1';
  }

  function closeModal(id) {
    var modal = qs('#' + id + '-dialog');
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');

    var trigger = qs('[data-ts-mcf-open="' + id + '"]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }

    delete modal.dataset.tsOpen;
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-ts-mcf-open]');
    if (openBtn) {
      e.preventDefault();
      openModal(openBtn.getAttribute('data-ts-mcf-open'), openBtn);
      return;
    }

    var closeBtn = e.target.closest('[data-ts-mcf-close]');
    if (closeBtn) {
      e.preventDefault();
      closeModal(closeBtn.getAttribute('data-ts-mcf-close'));
      return;
    }

    var openModalEl = qs('.ts-mcf-modal[data-ts-open="1"]');
    if (openModalEl) {
      var panel = qs('.ts-mcf-modal__panel', openModalEl);
      if (panel && !panel.contains(e.target) && openModalEl.contains(e.target)) {
        var openId = (openModalEl.id || '').replace(/-dialog$/, '');
        if (openId) closeModal(openId);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    var openModalEl = qs('.ts-mcf-modal[data-ts-open="1"]');
    if (!openModalEl) return;

    var id = (openModalEl.id || '').replace(/-dialog$/, '');
    if (id) closeModal(id);
  });
})();
